module.exports = __webpack_public_path__ + "static/media/cart-thin.5d1fb714.svg";